import React from 'react'

import { Formik } from 'formik'

import { AdminContext } from 'contexts/AdminContext'
import { ZariContext } from '_zari/context'

import { Portlet, Form, Button, Row, Col } from '_zari/core'
import Yup from '_zari/validation/_yup'

import { CodigosTransaccionesConstant } from 'constants/index'

import { TipoCambioModal } from 'sharedComponents/modals'

import { DownloadAxiosFile } from 'utils'

import * as AsientoContableService from 'services/asientosContables.service'

import * as FormGroups from './formGroups'

const portletBreadcrumbs = [
  { name: 'Asientos Contables', path: `/${CodigosTransaccionesConstant.ASIENTOSCONTABLES_LISTA}` },
  { name: 'Reportes' },
  { name: 'Registro Ventas' }
]

export const ValidationSchema = Yup.object().shape({
  mes: Yup.string().length(2).required()
})

const FormatoRegistroVentas = () => {
  const __adminContext = React.useContext(AdminContext)
  const __zariContext = React.useContext(ZariContext)

  const [mostrarTipoCambioModal, setMostrarTipoCambioModal] = React.useState(false)

  const formInitialValues = React.useMemo(() => {
    return {
      mes: __adminContext.mesTrabajo || ''
    }
  }, [__adminContext])

  const onSubmit = React.useCallback(
    async formData => {
      __zariContext.loader.open('Descargando registro de ventas ...')
      await AsientoContableService.descargarRegistroVentas(formData)
        .then(({ data, headers }) => {
          DownloadAxiosFile.downloadAsBlob(data, headers, 'registro-ventas.xlsx')
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
        .finally(() => {
          __zariContext.loader.close()
        })
    },
    [__zariContext]
  )

  return (
    <>
      <Portlet>
        <Portlet.Header title='Registro Ventas' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          {__adminContext.mesTrabajo && (
            <Formik initialValues={formInitialValues} validationSchema={ValidationSchema} onSubmit={onSubmit}>
              {({ errors, touched, isSubmitting, handleSubmit, values }) => (
                <Form>
                  <Row>
                    <Col md={4}>
                      <FormGroups.MesContabilidadFormGroup
                        iError={errors.mes}
                        iTouched={touched.mes}
                        fIsSubmitting={isSubmitting}
                      />
                      <Row>
                        <Col md={12} className='text-right'>
                          <Button onClick={() => setMostrarTipoCambioModal(true)}>Tipos Cambio</Button>
                          <Button disabled={isSubmitting} onClick={handleSubmit}>
                            {isSubmitting ? 'Descargando reporte ...' : 'Descargar'}
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          )}
        </Portlet.Body>
      </Portlet>
      {mostrarTipoCambioModal && (
        <TipoCambioModal show={mostrarTipoCambioModal} handleClose={() => setMostrarTipoCambioModal(false)} />
      )}
    </>
  )
}

export default React.memo(FormatoRegistroVentas)
